<admin-page-second [title]="'pages.channels.channels' | translate">
  <admin-section-standard [title]="'pages.channels.channels' | translate">

    <admin-panel-empty>
      <div class="row align-items-center">
        <div class="col-2 fw-semibold text-dark">Frontends</div>
        <div class="col-10">
          <div class="form-check form-check-inline" style="width: 10%">
            <input class="form-check-input" type="checkbox" [(ngModel)]="frontend.api" name="frontendApi" id="frontendApi">
            <label class="form-check-label" for="frontendApi">api</label>
          </div>
          <div class="form-check form-check-inline" style="width: 10%">
            <input class="form-check-input" type="checkbox" [(ngModel)]="frontend.batch" name="frontendBatch" id="frontendBatch">
            <label class="form-check-label" for="frontendBatch">batch</label>
          </div>
          <div class="form-check form-check-inline" style="width: 10%">
            <input class="form-check-input" type="checkbox" [(ngModel)]="frontend.realtime" name="frontendRealtime" id="frontendRealtime">
            <label class="form-check-label" for="frontendRealtime">realtime</label>
          </div>
<!--          <div class="form-check form-check-inline" style="width: 10%">-->
<!--            <input class="form-check-input" type="checkbox" [(ngModel)]="frontend.ocr" name="frontendOcr" id="frontendOcr">-->
<!--            <label class="form-check-label" for="frontendOcr">ocr</label>-->
<!--          </div>-->
<!--          <div class="form-check form-check-inline" style="width: 10%">-->
<!--            <input class="form-check-input" type="checkbox" [(ngModel)]="frontend.nlp" name="frontendNlp" id="frontendNlp">-->
<!--            <label class="form-check-label" for="frontendNlp">nlp</label>-->
<!--          </div>-->
<!--          <div class="form-check form-check-inline" style="width: 10%">-->
<!--            <input class="form-check-input" type="checkbox" [(ngModel)]="frontend.ai" name="frontendAi" id="frontendAi">-->
<!--            <label class="form-check-label" for="frontendAi">ai</label>-->
<!--          </div>-->
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-2 fw-semibold text-dark">Verticals</div>
        <div class="col-10">
          <div class="form-check form-check-inline" style="width: 10%">
            <input class="form-check-input" type="checkbox" [(ngModel)]="vertical.list" name="verticalList" id="verticalList">
            <label class="form-check-label" for="verticalList">list</label>
          </div>
          <div class="form-check form-check-inline" style="width: 10%">
            <input class="form-check-input" type="checkbox" [(ngModel)]="vertical.db" name="verticalDb" id="verticalDb">
            <label class="form-check-label" for="verticalDb">db</label>
          </div>
          <div class="form-check form-check-inline" style="width: 10%">
            <input class="form-check-input" type="checkbox" [(ngModel)]="vertical.wlm" name="verticalWlm" id="verticalWlm">
            <label class="form-check-label" for="verticalWlm">wlm</label>
          </div>
          <div class="form-check form-check-inline" style="width: 10%">
            <input class="form-check-input" type="checkbox" [(ngModel)]="vertical.cdd" name="verticalCdd" id="verticalCdd">
            <label class="form-check-label" for="verticalCdd">cdd</label>
          </div>
          <div class="form-check form-check-inline" style="width: 10%">
            <input class="form-check-input" type="checkbox" [(ngModel)]="vertical.aml" name="verticalAml" id="verticalAml">
            <label class="form-check-label" for="verticalAml">aml</label>
          </div>
        </div>
      </div>

      <div class="row align-items-center mb-5">
        <div class="col-2 fw-semibold text-dark">Data</div>
        <div class="col-10">
          <div class="form-check form-check-inline" style="width: 10%">
            <input class="form-check-input" type="checkbox" [(ngModel)]="data.entry" name="dataEntry" id="dataEntry">
            <label class="form-check-label" for="dataEntry">entry</label>
          </div>
          <div class="form-check form-check-inline" style="width: 10%">
            <input class="form-check-input" type="checkbox" [(ngModel)]="data.event" name="dataEvent" id="dataEvent">
            <label class="form-check-label" for="dataEvent">event</label>
          </div>
          <div class="form-check form-check-inline" style="width: 10%">
            <input class="form-check-input" type="checkbox" [(ngModel)]="data.request" name="dataRequest" id="dataRequest">
            <label class="form-check-label" for="dataRequest">request</label>
          </div>
          <div class="form-check form-check-inline" style="width: 10%">
            <input class="form-check-input" type="checkbox" [(ngModel)]="data.customer" name="dataCustomer" id="dataCustomer">
            <label class="form-check-label" for="dataCustomer">customer</label>
          </div>
          <div class="form-check form-check-inline" style="width: 10%">
            <input class="form-check-input" type="checkbox" [(ngModel)]="data.account" name="dataAccount" id="dataAccount">
            <label class="form-check-label" for="dataAccount">account</label>
          </div>
          <div class="form-check form-check-inline" style="width: 10%">
            <input class="form-check-input" type="checkbox" [(ngModel)]="data.transaction" name="dataTransaction" id="dataTransaction">
            <label class="form-check-label" for="dataTransaction">transaction</label>
          </div>
        </div>
      </div>
    </admin-panel-empty>

    <ng-template #noSelectedChannels>
      <h5 class="border-top border-1 pt-3">No channels found.</h5>
    </ng-template>

    <admin-panel-empty *ngIf="selectedChannels.length > 0; else noSelectedChannels">
      <admin-table-standard [items]="selectedChannels">
        <ng-template #header>
          <th style="width: 10%">{{ 'pages.tables.channels.frontend' | translate }}</th>
          <th style="width: 10%">{{ 'pages.tables.channels.data' | translate }}</th>
          <th style="width: 10%">{{ 'pages.tables.channels.vertical' | translate }}</th>
          <th style="width: 10%">{{ 'pages.tables.channels.code' | translate }}</th>
          <th style="width: 40%">{{ 'pages.tables.channels.description' | translate }}</th>
          <th style="width: 10%">&nbsp;</th>
        </ng-template>
        <ng-template #first let-item>
          <td>{{ item.frontend }}</td>
          <td>{{ item.data }}</td>
          <td>{{ item.vertical }}</td>
          <td>{{ item.code }}</td>
          <td class="text-truncate-custom">{{ item.description }}</td>
          <td class="justify-content-around text-end ps-0 pe-0 weight-label">
            <a routerLink="/admin/channel/{{item.owner}}/{{item.vertical}}/{{item.code}}" class="text-decoration-none text-purple action-buttons">
              <i class="bi bi-gear"></i>&nbsp;Config
            </a>
          </td>
        </ng-template>
      </admin-table-standard>
    </admin-panel-empty>
  </admin-section-standard>
</admin-page-second>
